import React, { useEffect, useState } from 'react';

import { getReport, IReport, IUser } from '~/src/dash/api/console-api';
import { getUserByID } from '~/src/dash/apiV2/user';
import { parseLocation } from '~/src/dash/router/routes';
import { useBaseStore } from '~/src/dash/views/base/contexts';
import { ReportBuilderNew } from '~/src/dash/views/reporting/ReportBuilder';

export const ReportBuilderExisting = () => {
  const { user } = useBaseStore();
  const [report, setReport] = useState<IReport | null>(null);
  const [createdByUser, setCreatedByUser] = useState<IUser | null>(null);

  const [isLoading, setIsLoading] = useState(true);

  const urlParams = new URLSearchParams(window.location.href.split('?')[1]);
  const savedAsQuickReport = urlParams.get('savedAsQuickReport') === 'true' ? true : false;

  if (createdByUser && report) {
    report.User = createdByUser;
  }

  useEffect(() => {
    const loc = parseLocation(window.location.href);
    getReport({
      query: {
        publisher_id: user.publisher.ID,
        report_id: loc.report,
      },
    })
      .then((report: IReport) => {
        getUserByID(report.UserID as number)
          .then((user: IUser) => {
            setCreatedByUser(user);
            setReport(report);
          })
          .catch((err: Error) => {
            console.error(err);
          });
      })
      .catch((err: Error) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <ReportBuilderNew
      report={report}
      setReport={setReport}
      isLoadingReport={isLoading}
      savedAsQuickReport={savedAsQuickReport}
    />
  );
};
